import { COLOR2, COLOR4, RADIO_COLOR } from '../../constants';

export const LoginAddressStyles = {
  mainContainer: {
    background: '#F8F8F8',
    padding: '20px',
    '@media (max-width:600px)': {
      padding: '10px 10px 15px 10px',
    },
  },

  secondaryContainer: {
    background: '#FFFFFF',
    height: '100%',
  },

  imgStyles: {
    maxWidth: '100%',
    height: 'auto',
  },

  detailsContainer: {
    border: '1px solid #D0D0D0',
    borderRadius: '6px',
    boxShadow: '0px 4px 4px 0px rgba(0,0,0,0.21)',
    '@media (max-width:600px)': {
      border: 'none',
      borderRadius: 'none',
      boxShadow: 'none',
    },
  },

  detailsContainerGrid: {
    padding: '40px 30px 30px 20px',
    '@media (max-width:600px)': {
      padding: '0px',
    },
  },

  welcomeMessage: {
    padding: '39px 36px 37px 30px',
    borderBottom: '1px solid #C5CEE0',
    font: '700 30px/40px TTNormsProBold',
    '@media (max-width:600px)': {
      padding: '19px 0px 20px 0px',
      margin: '0px 20px 0px 20px',
      font: 'normal 700 28px TTNormsProBold',
    },
  },

  welcomeMessageBundle: {
    padding: '10px 0 10px 0',
    font: '700 30px/40px TTNormsProBold',
    '@media (max-width:600px)': {
      font: 'normal 700 28px TTNormsProBold',
    },
  },

  error_message: {
    font: 'normal normal normal 14px/16px Arial',
    letterSpacing: '0.1px',
    color: COLOR2,
    opacity: 1,
    position: 'relative',
    top: '3px',
    display: 'block',
  },

  secondaryDetailsContainer: {
    padding: '30px',
    '@media (max-width:600px)': {
      padding: '30px 20px 30px 20px',
    },
  },
  secondaryBundleDetailsContainer: {
    padding: '30px 0 30px 0',
    '@media (max-width:600px)': {
      padding: '30px 20px 30px 20px',
    },
  },

  mailinAddressLabel: {
    marginBottom: '17px',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#444444',
    letterSpacing: '0.1px',
    textAlign: 'left',
    position: 'relative',
    fontFamily: 'Arial',
  },

  mailinAddressLabelTrue: {
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#444444',
    letterSpacing: '0.1px',
    textAlign: 'left',
    position: 'relative',
    marginBottom: '12px',
    fontFamily: 'Arial',
  },

  switch_heading: {
    marginRight: '10px',
    color: '#000000',
    fontFamily: 'Arial',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 'normal',
  },

  next_btn: {
    border: `1px solid ${RADIO_COLOR}`,
    background: `${RADIO_COLOR} 0% 0% no-repeat padding-box`,
    borderRadius: '56px',
    height: '56px',
    opacity: 1,
    font: 'normal 700 18px/24px TTNormsProRegular',
    textTransform: 'none',
    color: COLOR4,
    width: '100%',
    marginTop: '30px',
    '@media (max-width:600px)': {
      font: 'normal 700 16px Arial',
    },
    '&:hover': {
      backgroundColor: RADIO_COLOR,
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: '2px',
    },
    '&.Mui-disabled span': {
      opacity: 0.6,
    },
  },

  next_btn_disabled: {
    '&.MuiButton-root.Mui-disabled': {
      background: '#F3F3F3',
      border: '#F3F3F3',
      borderRadius: '56px',
      height: '56px',
      color: '#D0D0D0',
      font: 'normal 700 18px/24px TTNormsProRegular',
      letterSpacing: '1.01px',
      textTransform: 'none',
      '@media (max-width:600px)': {
        font: 'normal 700 16px Arial',
      },
      '&:hover': {
        backgroundColor: '#F3F3F3',
      },
    },
  },

  mobileInputDisabled: {
    border: '1px solid #E4E9F2 !important',
    background: '#F3F3F3 !important',
    '& .MuiInputBase-root.Mui-disabled': {
      border: 'none',
    },
  },
};
